import { render, staticRenderFns } from "./PriceAdjustDialog.vue?vue&type=template&id=2d97e834"
import script from "./PriceAdjustDialog.vue?vue&type=script&lang=js"
export * from "./PriceAdjustDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceAdjustDialog.vue?vue&type=style&index=0&id=2d97e834&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d97e834')) {
      api.createRecord('2d97e834', component.options)
    } else {
      api.reload('2d97e834', component.options)
    }
    module.hot.accept("./PriceAdjustDialog.vue?vue&type=template&id=2d97e834", function () {
      api.rerender('2d97e834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/jdSrot/components/PriceAdjustDialog.vue"
export default component.exports